import Modal from "../../common/atoms/modal";
import React, {useState} from "react";
import {FormGroup, FormLabel} from "../../common/atoms/formElements";
import Button from "../../common/atoms/button";
import CustomInput from "../../common/components/CustomInput";
import Utility from "../../utility";
import subscriptionPlans from "../../services/subscriptionPlans";

const AddSubscriptionPlanModal = ({isVisible, setVisible, refreshPlans}) => {
    const [planObject, setPlan] = useState({})
    const handleChange = (e) => {
        const {id, checked, value, type} = e.target;

        if (id.includes("_SCOPE") && type === "checkbox") {
            const scopeKey = id.replace("_SCOPE", ""); // e.g. "tryOnScope" -> "tryOn"
            setPlan((prevPlan) => {
                const currentScope = prevPlan.scope || [];
                let updatedScope = [...currentScope];
                if (checked) {
                    if (!updatedScope.includes(scopeKey)) {
                        updatedScope.push(scopeKey);
                    }
                } else {
                    updatedScope = updatedScope.filter(item => item !== scopeKey);
                }
                return {...prevPlan, scope: updatedScope};
            });
        } else {
            setPlan((prevPlan) => ({...prevPlan, [id]: value}));
        }
    };

    const onAddPlan = async (e) => {
        e.preventDefault();

        const data = planObject.scope?.join(",")
        const planData = {
            razorPayPlanId: planObject.razorPayPlanId,
            name: planObject.name,
            description: planObject.description,
            price: planObject.price,
            noOfDays: planObject.noOfDays,
            scope: data
        };
        let [err, planAddSuccess] = await Utility.parseResponse(subscriptionPlans.addPlans(planData));
        if (!planAddSuccess || err) {
            return Utility.apiFailureToast("Unable to add plan");
        }

        refreshPlans();
        onModalClose();
    };

    const onModalClose = () => {
        setVisible(false)
    }

    return (
        <Modal isVisible={isVisible} onClose={onModalClose} title={'Add Plan'}>
            <FormGroup>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "start",
                    gap: "20px",
                    width: "100%",
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        gap: "5px",
                        alignItems: "start",
                        width: '50%',
                    }}>
                        <FormLabel isMandatory={true} label='RazorPayPlan Id'/>
                        <CustomInput id='razorPayPlanId' onChange={handleChange}/>

                        <FormLabel isMandatory={true} label='Amount'/>
                        <CustomInput id='price' type='number' onChange={handleChange}/>
                        <FormLabel isMandatory={true} label='Description'/>
                        <textarea style={{width: '100%', outline: 'none', border: 'solid 1px #dfe1e6'}} id='description'
                                  onChange={handleChange}/>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        gap: "5px",
                        alignItems: "start",
                        width: '50%',
                    }}>
                        <FormLabel isMandatory={true} label='Plan Name'/>
                        <CustomInput id='name' onChange={handleChange}/>
                        <FormLabel isMandatory={true} label='No of days'/>
                        <CustomInput id='noOfDays' type='number' onChange={handleChange}/>
                        <FormLabel isMandatory={true} label='Scope'/>
                        <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px"}}>
                            <div style={{display: "flex", gap: "5px"}}>
                                <input id={"AR_OPTION_SCOPE"} type={"checkbox"} onChange={handleChange}/>
                                <FormLabel label='Try On'/>
                            </div>
                            <div style={{display: "flex", gap: "5px"}}>
                                <input id={"ADD_TO_CATALOGUE_SCOPE"} type={"checkbox"} onChange={handleChange}/>
                                <FormLabel label='Add to catalogue'/>
                            </div>
                            <div style={{display: "flex", gap: "5px"}}>
                                <input id={"SAVE_SCOPE"} type={"checkbox"} onChange={handleChange}/>
                                <FormLabel label='Save'/>
                            </div>
                            <div style={{display: "flex", gap: "5px"}}>
                                <input id={"SHARE_SCOPE"} type={"checkbox"} onChange={handleChange}/>
                                <FormLabel label='Share'/>
                            </div>
                        </div>

                    </div>
                </div>
                <br/>
                <Button onClick={onAddPlan}>Add plan</Button>
            </FormGroup>
        </Modal>
    )
}
export default AddSubscriptionPlanModal
